import { Text, HStack } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { MetaInformation } from '@novaheal/types';
import parse from 'html-react-parser';
import { htmlToReactOptions } from '../../utils/htmlToReactOptions';

type Props = {
  metaData: MetaInformation[];
};

export const MetaSection = ({ metaData }: Props): ReactElement => {
  const metaDataText = metaData
    .map((meta) => meta.value.replaceAll('\n', '<br/>'))
    .join('<br/><br/>');

  return (
    <HStack
      align="left"
      gap="10px"
      alignItems="stretch"
      mb="30px"
      mt="l"
      px={{ base: 'l', md: '40px' }}
    >
      <Text flex="0 1 auto" color="text.primary" textStyle="body.s.regular">
        {parse(metaDataText, htmlToReactOptions)}
      </Text>
    </HStack>
  );
};
